import { reactive } from 'vue';

export const store = reactive({
    no_more_results: false,
});

export default store;
